module.exports = __webpack_public_path__ + "static/media/loading-avatar.82321c10.svg";